

import React from "react";
// Returns JSX for S3 and local file links/buttons
// Usage: renderFileLinks(file, downloadS3)

// helpers/fileLinks.js
// Helper functions for generating file download/view links for S3 and local files

import { MEDIA_URL, S3_BUCKET, S3_ENDPOINT, S3_KEY, S3_REGION, S3_SECRET, B2_BUCKET, B2_ENDPOINT } from "../configs";
//import AWS from "aws-sdk";
import axios from "axios";
import fileSaver from "file-saver";
import fileAPI from "../api/fileAPI"; // Import

// Download handler for Backblaze B2
// Usage: downloadB2(path, filename, storageLocationObj)
export async function downloadB2(fileId, filename = 'file', storageLocation = {}) {
  try {
    // If a direct download URL is provided in metadata, use it
    if (storageLocation.url) {
      const res = await axios.get(storageLocation.url, { responseType: 'blob' });
      const blob = new File([res.data], filename);
      fileSaver.saveAs(blob);
      return;
    }

    // Prefer file_id from storageLocation, fallback to options
    // const fileId = storageLocation.file_id || storageLocation._id;
    if (!fileId) throw new Error('Missing file_id for B2 download');

    console.log('Fetching B2 signed URL for fileId:', fileId);

    // Fetch signed URL from backend
    const data = await fileAPI.getB2SignedUrl(fileId);
    if (!data || !data.url) throw new Error('No signed URL returned from backend');
    const signedUrl = data.url;

    // Download the file using the signed URL
    const fileResp = await axios.get(signedUrl, { responseType: 'blob' });
    const blob = new File([fileResp.data], filename);
    fileSaver.saveAs(blob);
  } catch (err) {
    console.error('B2 download failed:', err);
    //alert('Failed to download file from Backblaze B2.');
  }
}

export function getS3DownloadHandler() {
  return 'not_implemented';
  // return (filepath, filename) => {
  //   const s3 = new AWS.S3();
  //   s3.config.update({
  //     accessKeyId: S3_KEY,
  //     secretAccessKey: S3_SECRET,
  //     region: S3_REGION,
  //     endpoint: S3_ENDPOINT,
  //     signatureVersion: "v4",
  //   });
  //   const params = { Bucket: S3_BUCKET, Key: filepath };
  //   s3.getSignedUrl("getObject", params, function (err, url) {
  //     axios.get(`${url}`, { responseType: "blob" }).then((res) => {
  //       const blob = new File([res.data], `${filename}`);
  //       fileSaver.saveAs(blob);
  //     });
  //   });
  // };
}

export function getLocalFileUrl(path) {
  return `${MEDIA_URL}${path}`;
}

// options: { downloadStatus } for disabling S3 button
export function renderFileLinks(file, downloadS3, options = {}) {
  return <>
    {file.aws_path && (
      <button
        type="button"
        className="me-2 border-0 bg-transparent"
        onClick={(e) => {
          e.preventDefault();
          //downloadS3(file.aws_path, file.filename);
        }}
        disabled={options.downloadStatus}
        alt={file.filename}
      >
        <span className="badge border border-warning bg-warning bg-opacity-10 text-warning">
          {"S3"}
        </span>
      </button>
    )}
    {file.path && (
      <a
        href={getLocalFileUrl(file.path)}
        className="me-2"
        alt={file.filename}
        target="_blank"
        rel="noreferrer"
      >
        <span className="badge bg-secondary bg-opacity-75 text-light border border-secondary">
          {"Local"}
        </span>
      </a>
    )}
  </>;
}

// Render a single storage link based on storage type
// Usage: renderSingleStorageLink(storage_type, file, location_data, options)
// storage_type: string - type of storage ('aws_s3', 'backblaze_b2', 'local_server')
// file: object containing file info like _id, filename, etc.
// location_data: object containing path, key, file_id, etc. for the specific storage
// options: optional configuration object
export function renderSingleStorageLink(storage_type, file = {}, location_data = {}, options = {}) {
  if (!storage_type) return null;
  
  const fileId = file._id || file.id || "";
  const filename = location_data.filename || file.filename || 'file';
  const path = location_data.path || location_data.key || "";
  
  // Download handlers
  const downloadS3 = getS3DownloadHandler();
  
  let label = storage_type.replace(/_/g, ' ').toUpperCase();
  let link = null;
  let badgeClass = 'bg-secondary';
  
  switch (storage_type) {
    case 'local_server':
      return (
        <button
          type="button"
          className="me-2 p-0 border-0 bg-transparent"
          onClick={e => { e.preventDefault(); window.open(getLocalFileUrl(path), '_blank'); }}
          alt={filename || fileId}
          disabled={options.disabled}
        >
          <span className="badge border border-secondary bg-secondary bg-opacity-10 text-secondary">LS</span>
        </button>
      );
    case 'aws_s3':
      return (
        <button
          type="button"
          className="me-2 border-0 bg-transparent"
          onClick={e => { 
            e.preventDefault(); 
            // downloadS3(path, filename); 
          }}
          alt={filename || fileId}
          disabled={options.disabled}
        >
          <span className="badge border border-warning bg-warning bg-opacity-10 text-warning">S3</span>
        </button>
      );
    case 'backblaze_b2':
      return (
        <button
          type="button"
          className="me-2 p-0 border-0 bg-transparent"
          onClick={e => { e.preventDefault(); downloadB2(fileId, filename, location_data); }}
          alt={filename || fileId}
          disabled={options.disabled}
        >
          <span className="badge border border-info bg-info bg-opacity-10 text-info">B2</span>
        </button>
      );
    // Add more storage types as needed
    default:
      return null;
  }
  
  // if (link) {
  //   return (
  //     <a
  //       href={link}
  //       className="me-2"
  //       alt={filename || path}
  //       target="_blank"
  //       rel="noreferrer"
  //     >
  //       <span className={`badge ${badgeClass} bg-opacity-75 text-light border border-secondary`}>{label}</span>
  //     </a>
  //   );
  // }
  
  // return null;
}

// Render download/view links for multiple storage locations
// Usage: renderStorageLinks(file, options)
// file: object containing storage_locations (array), _id or id, filename, etc.
export function renderStorageLinks(file = {}, options = {}) {
  const storage_locations = file.storage_locations || [];
  const fileId = file._id || file.id || "";
  if (!Array.isArray(storage_locations) || storage_locations.length === 0) return null;

  // Download handlers
  const downloadS3 = getS3DownloadHandler();

  // Helper to get label and link for each storage type
  const getLink = (loc) => {
    const { storage_type, path, status } = loc;
    if (status !== 'active') return null;
    let label = storage_type.replace(/_/g, ' ').toUpperCase();
    let link = null;
    let badgeClass = 'bg-secondary';
    const filename = loc.filename || file.filename || 'file';
    switch (storage_type) {
      case 'local_server':
        return (
          <button
            type="button"
            className="me-2 p-0 border-0 bg-transparent"
            onClick={e => { e.preventDefault(); window.open(getLocalFileUrl(path), '_blank'); }}
            alt={filename || fileId}
            disabled={options.disabled}
          >
            <span className="badge border border-secondary bg-secondary bg-opacity-10 text-secondary">LS</span>
          </button>
        );
      case 'aws_s3':
        return (
          <button
            type="button"
            className="me-2 border-0 bg-transparent"
            onClick={e => { 
              e.preventDefault(); 
              // downloadS3(loc.path, filename); 
            }}
            alt={filename || fileId}
          >
            <span className="badge border border-warning bg-warning bg-opacity-10 text-warning">S3</span>
          </button>
        );
      case 'backblaze_b2':
        return (
          <button
            type="button"
            className="me-2 p-0 border-0 bg-transparent"
            onClick={e => { e.preventDefault(); downloadB2(fileId, filename, loc); }}
            alt={filename || fileId}
          >
            <span className="badge border border-info bg-info bg-opacity-10 text-info">B2</span>
          </button>
        );
      // Add more storage types as needed
      default:
        break;
    }
    if (link) {
      return (
        <a
          href={link}
          className="me-2"
          alt={filename || path}
          target="_blank"
          rel="noreferrer"
        >
          <span className={`badge ${badgeClass} bg-opacity-75 text-light border border-secondary`}>{label}</span>
        </a>
      );
    }
    return null;
  };

  return (
    <>
      {storage_locations.map((loc, i) => {
        const el = getLink(loc);
        if (!el) return null;
        const key = `${loc.storage_type || 'storage'}-${loc.path || ''}-${i}`;
        return React.cloneElement(el, { key });
      })}
    </>
  );
}